/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Derived from publication status, registration window, and session times
 */
export enum SeminarOccurrenceLifecycleStatus {
    DRAFT = 'draft',
    REGISTRATION_PENDING = 'registration_pending',
    REGISTRATION_OPEN = 'registration_open',
    REGISTRATION_CLOSED = 'registration_closed',
    RUNNING = 'running',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
}
